/* Bored George - "Personalise your case" on single product pages.

   Deliberately NOT the old approach. The previous version let the theme add
   the item, then popped a modal on a 2 second timer and made a second cart
   call - which is where the races and half-added carts came from.

   Here the click is intercepted before the theme's form handler runs, the
   shopper answers once, and the sunglasses plus the case go to the cart in a
   single request. If that request fails for any reason the click is handed
   straight back to the theme's own form, so a shopper can never end up unable
   to buy because an upsell broke.

   BACKING OUT IS NOT CANCELLING. The shopper reached this panel by pressing
   Add to cart, so the pair is already asked for; only the case is in question.
   The X, the backdrop and Escape therefore all run dismiss(), which does
   exactly what Skip does - adds the pair, no case. close() on its own is only
   for paths where the cart has already been dealt with. Wiring an exit
   straight to close() is the bug this replaced: the panel vanished and nothing
   was added. */
(function () {
  'use strict';

  function money(cents) {
    var parts = (cents / 100).toFixed(2).split('.');
    var whole = parts[0];
    var grouped = '';
    while (whole.length > 3) {
      grouped = ',' + whole.slice(-3) + grouped;
      whole = whole.slice(0, -3);
    }
    return '$' + whole + grouped + '.' + parts[1];
  }

  function cleanInitials(raw) {
    var upper = (raw || '').toUpperCase();
    var out = '';
    for (var i = 0; i < upper.length; i++) {
      var ch = upper.charAt(i);
      if (ch >= 'A' && ch <= 'Z') out += ch;
    }
    return out;
  }

  function init(root) {
    if (!root || root.dataset.ready === 'true') return;

    var cfg = {};
    try { cfg = JSON.parse(root.dataset.config || '{}'); } catch (e) { return; }
    if (!cfg.firstId) return;

    /* Scope to this block's own form, so a quick-add drawer elsewhere on the
       page can never be driven by the wrong panel. */
    var scope = root.closest('.buy-buttons-block') || document;
    var form = scope.querySelector('form[data-type="add-to-cart-form"]');
    if (!form) return;

    root.dataset.ready = 'true';

    var row = root.querySelector('.bgp__row');
    var input = root.querySelector('[data-bgpdp-input]');
    var rowPrice = root.querySelector('[data-bgpdp-price]');
    var addBtn = root.querySelector('[data-bgpdp-add]');
    var skipBtn = root.querySelector('[data-bgpdp-skip]');
    var errorEl = root.querySelector('[data-bgpdp-error]');

    var busy = false;
    var bypass = false;

    function currentVariant() {
      var el = form.querySelector('[name="id"]');
      return el ? el.value : '';
    }

    function currentQty() {
      var el = form.querySelector('[name="quantity"]');
      var n = el ? parseInt(el.value, 10) : 1;
      return n > 0 ? n : 1;
    }

    function unitPrice() {
      var p = (cfg.prices || {})[String(currentVariant())];
      return typeof p === 'number' ? p : 0;
    }

    /* Same ladder as the bundle: full price for the first case, the cheaper
       product for every case after it. */
    function casesTotal() {
      if (!input || !input.value) return 0;
      var q = currentQty();
      var first = cfg.firstPrice || 0;
      var extra = cfg.extraId ? (cfg.extraPrice || 0) : first;
      return first + (Math.max(0, q - 1) * extra);
    }

    function paint() {
      var on = !!(input && input.value);
      if (row) row.dataset.on = on ? 'true' : 'false';
      if (rowPrice) rowPrice.textContent = on ? money(casesTotal()) : '';
      if (addBtn) {
        addBtn.textContent = (cfg.addLabel || 'Add to cart')
          + ' · ' + money((unitPrice() * currentQty()) + casesTotal());
      }
    }

    function open() {
      if (input) input.value = '';
      if (errorEl) errorEl.hidden = true;
      if (addBtn) addBtn.dataset.busy = 'false';
      paint();
      root.hidden = false;
      document.body.style.overflow = 'hidden';
    }

    function close() {
      root.hidden = true;
      document.body.style.overflow = '';
    }

    /* Backing out declines the CASE, not the sunglasses - identical to Skip.
       Hidden first so the exit feels immediate; the cart request carries on
       behind it and opens the drawer when it lands. */
    function dismiss() {
      if (busy) return;
      close();
      submit(false);
    }

    function handBackToTheme() {
      bypass = true;
      close();
      if (typeof form.requestSubmit === 'function') form.requestSubmit();
      else form.submit();
    }

    function submit(withCase) {
      if (busy) return;
      busy = true;
      if (addBtn) addBtn.dataset.busy = 'true';
      if (errorEl) errorEl.hidden = true;

      var q = currentQty();
      var initials = (withCase && input) ? input.value : '';
      var items = [{ id: parseInt(currentVariant(), 10), quantity: q }];

      if (initials) {
        items.push({
          id: parseInt(cfg.firstId, 10),
          quantity: 1,
          properties: { 'Initials': initials, 'For': cfg.productTitle || 'Sunglasses' }
        });
        if (q > 1 && cfg.extraId) {
          items.push({
            id: parseInt(cfg.extraId, 10),
            quantity: q - 1,
            properties: { 'Initials': initials, 'For': cfg.productTitle || 'Sunglasses' }
          });
        }
      }

      var addUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root)
        ? window.Shopify.routes.root + 'cart/add.js'
        : '/cart/add.js';

      fetch(addUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (r) {
          if (!r.ok) throw new Error('cart');
          return r.json();
        })
        .then(function () {
          close();
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          if (typeof window.unicornOpenCart === 'function') {
            window.unicornOpenCart();
          } else {
            document.dispatchEvent(new CustomEvent('cart:open', { bubbles: true }));
          }
        })
        .catch(function () {
          handBackToTheme();
        })
        .finally(function () {
          busy = false;
          if (addBtn) addBtn.dataset.busy = 'false';
        });
    }

    /* Capture phase, before the theme's own submit handler. Only the plain
       Add to cart button - Shop Pay and the other accelerated buttons are
       left completely alone, because those shoppers are mid-checkout and an
       interruption there costs more than the upsell earns. */
    document.addEventListener('click', function (e) {
      if (bypass || busy) return;
      if (!root.hidden) return;
      var btn = e.target.closest('[name="add"], .add-to-cart-button');
      if (!btn || !form.contains(btn) || btn.disabled) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      open();
    }, true);

    if (input) {
      input.addEventListener('input', function () {
        this.value = cleanInitials(this.value);
        paint();
      });
    }

    if (addBtn) addBtn.addEventListener('click', function () { submit(true); });
    if (skipBtn) skipBtn.addEventListener('click', function () { submit(false); });

    /* X and backdrop. dismiss(), never close() - see the note at the top. */
    root.addEventListener('click', function (e) {
      if (e.target.closest('[data-bgpdp-close]')) dismiss();
    });

    document.addEventListener('keydown', function (e) {
      if (!root.hidden && e.key === 'Escape') dismiss();
    });

    /* Size changes behind the panel move the price. */
    form.addEventListener('change', paint);

    paint();
  }

  function boot() {
    document.querySelectorAll('[data-bgpdp]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
